// import fns from "../util/functions"

$(function(){


  // pagetop
  //------------------------------------------------------------
  var $btn = $('.js-pagetop');
  $btn.on('click', function(){
    $('html,body').animate({
      scrollTop: 0
    }, 600);
  });

  $(window).on('scroll load', function(){
    var scTop = $(window).scrollTop();
    if(scTop > 90){
      $("html").addClass("is-scrolled");
    } else{
      $("html").removeClass("is-scrolled");
    }
  });

  // js-mypage-pass
  //------------------------------------------------------------
  $(".js-mypage-pass").fancybox({
    content : $(".tmpl-mypage-pass").html(),
    closeBtn: false,
    padding: 0,
  })

  $(document).on('click', '.js-fancy-close', function(){
    $.fancybox.close()
  });

  // js-add-order
  //------------------------------------------------------------


  // // anchor link
  // //------------------------------------------------------------
  // $(document).on("click", "a[href^='#']", function(){

  //   // if( $("html").is(".width-sp") ) {
  //   //   var href = $(this).attr("href");
  //   //   var pos = $(href).offset().top;

  //   //   // 少しずらす
  //   //   $('html,body').animate({
  //   //     scrollTop: pos - 55
  //   //   }, 300);

  //   //   // 通常のリンク動作は無効化
  //   //   return false ;

  //   // } else {

  //   if( $("html").is(".width-sp") ) {
  //     $("html").removeClass("is-sidr");
  //   }

  //   var href = $(this).attr("href");
  //   var pos = $(href).offset().top;

  //   $('html,body').animate({
  //     scrollTop: pos
  //   }, 300);

  //   if( $("html").is(".theme-top") ) {
  //     fns.topPositions();
  //   }

  //   // 通常のリンク動作は無効化
  //   return false ;

  // });

});



// WEBPACK FOOTER //
// ./_src/js/action/action.js